import React, { useMemo } from 'react';
import { client } from '../redux/store';

interface FileDownloadLinkProps {
  path: string;
}
export const FileDownloadLink: React.FC<FileDownloadLinkProps> = ({ path, children }) => {
  const token = useMemo(() => client.defaults.headers.common['Authorization'].split(' ')[1], []);

  return (
    <a target="_blank" rel="noopener noreferrer" href={`${client.defaults.baseURL}${path}?token=${token}`}>
      {children}
    </a>
  );
};
